import { render, staticRenderFns } from "./GPagination.vue?vue&type=template&id=05055a16&"
import script from "./GPagination.vue?vue&type=script&lang=ts&"
export * from "./GPagination.vue?vue&type=script&lang=ts&"
import style0 from "./GPagination.vue?vue&type=style&index=0&lang=scss&scopoed=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports